module.exports = __webpack_public_path__ + "img/header-weddingRingsMorningGlow.942061b.jpg";